import React from "react";
import Header from "ui/molecules/Header";

const AppLayout: React.FunctionComponent = ({ children }) => {
  return (
    <div>
      <Header />
      {children}
    </div>
  );
};

export default AppLayout;
